import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

type Props = {
  value: number
  size?: number
  thickness?: number
};

const CircularProgressWithLabel: React.FC<Props> = ({
  value,
  size = 30,
  thickness = 4,
}) => (
  <Box position="relative" display="inline-flex">
    <CircularProgress
      variant="determinate"
      value={value}
      size={size}
      thickness={thickness}
    />
    <Box
      position="absolute"
      top={0}
      left={0}
      bottom={0}
      right={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Typography variant="caption" component="div" fontSize={size * 0.3}>
        {`${Math.round(value)}%`}
      </Typography>
    </Box>
  </Box>
)

export default CircularProgressWithLabel
